import { useContext } from 'react';

import { Button } from '@mui/material';

import { ConfirmDialog } from '../../../components/dialogs';
import { AlertSnackbarContext } from '../../../components/snackbars';
import { useRemoveAdditionalParent } from '../../../lib/sub-category/hooks/useRemoveAdditionalParent';

type RemoveParentCategoryButtonProps = {
  parentCategoryId: string;
  subCategoryId: string;
};

function RemoveParentCategoryButton({ parentCategoryId, subCategoryId }: RemoveParentCategoryButtonProps) {
  const [, setAlert] = useContext(AlertSnackbarContext);
  const { mutateAsync: removeAdditionalParentCategory, isLoading: isSubmitting } = useRemoveAdditionalParent();

  const handleSubmit = async () => {
    await removeAdditionalParentCategory(
      { subCategoryId, parentCategoryId },
      {
        onSuccess: () => {
          setAlert({ message: 'Parent category removed successfully', severity: 'success' });
        },
      },
    );
  };

  return (
    <ConfirmDialog
      trigger={(open) => (
        <Button onClick={open} variant="outlined" color="error" size="small">
          Remove
        </Button>
      )}
      title="Remove Parent Category"
      description="Are you sure you want to remove this parent category?"
      cancelBtnText={'Cancel'}
      submitBtnText={'Submit'}
      onConfirm={async (close) => {
        await handleSubmit();
        close();
      }}
      disabled={isSubmitting}
      loading={isSubmitting}
    />
  );
}

export default RemoveParentCategoryButton;
